import React from 'react'
import { Icon } from '@chakra-ui/react'

const sellHome = ({ ...props }) => {
  return (
    <Icon
      width="43"
      height="43"
      viewBox="0 0 43 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M17.6898 25.3501H20.6967V26.1001H17.6898V25.3501Z"
        fill="white"
      />
      <path
        d="M10.9243 33.6001H13.9312V36.6001H10.9243V33.6001Z"
        fill="white"
      />
      <path
        d="M22.2002 27.6001H25.2071V28.3501H22.2002V27.6001Z"
        fill="white"
      />
      <path
        d="M17.6898 27.6001H20.6967V28.3501H17.6898V27.6001Z"
        fill="white"
      />
      <path
        d="M34.2279 14.5396V6.6001H29.7175V10.0396L34.2279 14.5396Z"
        fill="white"
      />
      <path
        d="M19.8 7.93411L19.8569 7.87735C20.7371 7.00284 22.1598 7.00284 23.04 7.87735L38.1422 22.9447C38.4722 23.2718 39.0044 23.2718 39.3344 22.9447C39.6629 22.6159 39.6629 22.0841 39.3344 21.7553L21.9748 4.4379C21.6819 4.14896 21.2106 4.14896 20.9177 4.4379L19.3082 6.04337C19.531 6.65713 19.6954 7.28995 19.8 7.93411Z"
        fill="white"
      />
      <path
        d="M9.42079 18.6001C14.4028 18.6001 18.4416 14.5707 18.4416 9.6001C18.4416 4.62952 14.4028 0.600098 9.42079 0.600098C4.43874 0.600098 0.400024 4.62952 0.400024 9.6001C0.40553 14.5685 4.44094 18.5946 9.42079 18.6001ZM6.41387 11.8501H7.91733V12.6001C7.91733 13.0143 8.25392 13.3501 8.66906 13.3501H10.1725C10.5877 13.3501 10.9243 13.0143 10.9243 12.6001V11.1001C10.9243 10.6859 10.5877 10.3501 10.1725 10.3501H8.66906C7.42364 10.3501 6.41387 9.34265 6.41387 8.1001V6.6001C6.41387 5.35754 7.42364 4.3501 8.66906 4.3501V2.8501H10.1725V4.3501C11.4179 4.3501 12.4277 5.35754 12.4277 6.6001V7.3501H10.9243V6.6001C10.9243 6.18591 10.5877 5.8501 10.1725 5.8501H8.66906C8.25392 5.8501 7.91733 6.18591 7.91733 6.6001V8.1001C7.91733 8.51428 8.25392 8.8501 8.66906 8.8501H10.1725C11.4179 8.8501 12.4277 9.85754 12.4277 11.1001V12.6001C12.4277 13.8427 11.4179 14.8501 10.1725 14.8501V16.3501H8.66906V14.8501C7.42364 14.8501 6.41387 13.8427 6.41387 12.6001V11.8501Z"
        fill="#C0DFF8"
      />
      <path
        d="M22.2002 25.3501H25.2071V26.1001H22.2002V25.3501Z"
        fill="white"
      />
      <path d="M28.2141 3.6001H35.7314V5.1001H28.2141V3.6001Z" fill="white" />
      <path
        d="M25.2071 42.6001V32.1001H17.6898V42.6001H25.2071ZM18.4415 37.3501H19.1933V35.8501H18.4415V34.3501H19.945C20.3602 34.3501 20.6967 34.6859 20.6967 35.1001V38.1001C20.6967 38.5143 20.3602 38.8501 19.945 38.8501H18.4415V37.3501Z"
        fill="white"
      />
      <path
        d="M3.56255 21.7554C3.23477 22.0846 3.23477 22.6156 3.56255 22.9448C3.89216 23.2726 4.42513 23.2726 4.75474 22.9448L7.75029 19.9562C7.105 19.8525 6.47036 19.6892 5.85518 19.468L3.56255 21.7554Z"
        fill="white"
      />
      <path
        d="M9.74857 20.0838L9.73206 20.1003H33.1649L21.9748 8.93814C21.6819 8.6492 21.2106 8.6492 20.9177 8.93814L19.9263 9.92728C19.7475 15.46 15.2941 19.9043 9.74857 20.0838Z"
        fill="white"
      />
      <path
        d="M39.49 40.3501C39.0749 40.3501 38.7383 40.0143 38.7383 39.6001C38.7383 38.3575 37.7285 37.3501 36.4831 37.3501C35.2376 37.3501 34.2279 38.3575 34.2279 39.6001C34.2312 39.7927 34.2598 39.9843 34.3127 40.1692C34.374 40.3995 34.3218 40.6445 34.1728 40.8302C34.0234 41.0159 33.7948 41.1199 33.5565 41.1107C33.5312 41.1107 33.4552 41.1016 33.4295 41.0986C32.4891 41.1129 31.6581 41.712 31.3494 42.5986H42.4C42.0553 41.2762 40.8595 40.3523 39.49 40.3501Z"
        fill="white"
      />
      <path
        d="M7.16512 40.35C7.13136 40.3592 7.09649 40.3632 7.06125 40.3629C6.72869 40.3834 6.42441 40.1764 6.32163 39.8604C6.08378 39.1686 5.37866 38.75 4.65593 38.8716C3.93283 38.9932 3.40427 39.6187 3.40647 40.35C3.40867 40.5782 3.46373 40.8027 3.56724 41.0063C3.70929 41.2945 3.65167 41.6409 3.42409 41.868C3.19615 42.095 2.84855 42.1518 2.56004 42.0097C1.85419 41.6644 1.00079 41.9222 0.605469 42.6H10.0773C9.73305 41.2762 8.53608 40.3511 7.16512 40.35Z"
        fill="white"
      />
      <path
        d="M33.4703 37.3809C33.685 37.0923 33.9401 36.8359 34.2279 36.6195V21.6001H8.66907V39.1112C10.2092 39.658 11.3335 40.9921 11.6092 42.6001H16.1864V31.3501C16.1864 30.9359 16.523 30.6001 16.9381 30.6001H25.9589C26.374 30.6001 26.7106 30.9359 26.7106 31.3501V42.6001H29.8001C30.1015 41.1298 31.2514 39.9795 32.7244 39.6752C32.7244 39.6503 32.7244 39.625 32.7244 39.6001C32.7274 39.0376 32.8588 38.4835 33.1087 37.9792C32.9946 38.0547 32.8614 38.0964 32.7244 38.1001H28.2141C27.7989 38.1001 27.4623 37.7643 27.4623 37.3501V32.8501C27.4623 32.4359 27.7989 32.1001 28.2141 32.1001H32.7244C33.1396 32.1001 33.4762 32.4359 33.4762 32.8501V37.3501C33.4762 37.3615 33.4703 37.3702 33.4703 37.3809ZM15.4346 37.3501C15.4346 37.7643 15.0981 38.1001 14.6829 38.1001H10.1725C9.75739 38.1001 9.4208 37.7643 9.4208 37.3501V32.8501C9.4208 32.4359 9.75739 32.1001 10.1725 32.1001H14.6829C15.0981 32.1001 15.4346 32.4359 15.4346 32.8501V37.3501ZM26.7106 28.3501C26.7106 29.1785 26.0374 29.8501 25.2071 29.8501H17.6898C16.8596 29.8501 16.1864 29.1785 16.1864 28.3501V25.3501C16.1864 24.5217 16.8596 23.8501 17.6898 23.8501H25.2071C26.0374 23.8501 26.7106 24.5217 26.7106 25.3501V28.3501Z"
        fill="white"
      />
      <path
        d="M28.9658 33.6001H31.9727V36.6001H28.9658V33.6001Z"
        fill="white"
      />
    </Icon>
  )
}

export default sellHome
